import { Character } from '../../types/character';
import { MAX_CHARACTERS } from '../../context/CharacterContext';
import './CharacterSlotSelector.css';

interface CharacterSlotSelectorProps {
  characters: Character[];
  selectedCharacterId: string | null;
  maxSlots?: number;
  onSelectCharacter: (character: Character) => void;
  onCreateNew: () => void;
}

export function CharacterSlotSelector({
  characters,
  selectedCharacterId,
  maxSlots = MAX_CHARACTERS,
  onSelectCharacter,
  onCreateNew,
}: CharacterSlotSelectorProps) {
  // Create slot array with existing characters
  const slots: (Character | null)[] = [];
  for (let i = 0; i < maxSlots; i++) {
    const character = characters.find((c) => c.slotNumber === i + 1);
    slots.push(character || null);
  }

  const canCreateNew = characters.length < maxSlots;

  // Get initials from character name
  const getInitials = (name: string): string => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="character-slot-selector">
      <div className="slots">
        {slots.map((character, index) => (
          <button
            key={index}
            type="button"
            className={`slot ${character?.id === selectedCharacterId ? 'selected' : ''} ${
              character ? 'occupied' : 'empty'
            }`}
            onClick={() => {
              if (character) {
                onSelectCharacter(character);
              } else if (canCreateNew) {
                onCreateNew();
              }
            }}
            disabled={!character && !canCreateNew}
            title={character ? character.name : canCreateNew ? 'Create new character' : 'Slot locked'}
          >
            {character ? (
              <>
                <span className="slot-avatar">{getInitials(character.name)}</span>
                <span className="slot-name">{character.name}</span>
              </>
            ) : (
              <span className="slot-icon">{canCreateNew ? '+' : '🔒'}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default CharacterSlotSelector;
